/* WEB-07 (24-oct-2026) · Buscador abierto como el prototipo. Usa /search/suggest.json (buscador rápido de Shopify). */
(() => {
  const root = document.getElementById('W7Search');
  if (!root) return;
  const input = root.querySelector('input[type="search"]');
  const body = root.querySelector('.w7-so-body');
  const POP = ['jean', 'baggy', 'boxy', 'oversize', 'buzo', 'pack'];
  const LUPA = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M16.5 16.5L21 21"/></svg>';
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const $p = (n) => '$' + Math.round(n).toLocaleString('es-AR');
  const plana = () => document.querySelector('.w7-foto[open]') !== null;
  const img = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  // «Visto recién»: se guarda al entrar a una ficha (solo en este navegador)
  const VKEY = 'w7:vistos';
  const getVistos = () => { try { return JSON.parse(localStorage.getItem(VKEY) || '[]'); } catch (e) { return []; } };
  if (location.pathname.includes('/products/')) {
    try {
      const t = document.querySelector('meta[property="og:title"]')?.content;
      const i = document.querySelector('meta[property="og:image"]')?.content;
      const pr = document.querySelector('meta[property="og:price:amount"]')?.content;
      if (t) {
        const url = location.pathname.replace(/^.*(\/products\/[^/?#]+).*$/, '$1');
        const v = [{ t, i, url, pr: pr ? Number(pr.replace(/\./g, '').replace(',', '.')) : null }].concat(getVistos().filter((x) => x.url !== url)).slice(0, 4);
        localStorage.setItem(VKEY, JSON.stringify(v));
      }
    } catch (e) {}
  }

  const empty = () => {
    const vistos = getVistos();
    body.innerHTML = `<p class="w7-so-h">Lo más buscado</p><div class="w7-so-chips">${POP.map((t) => `<button type="button" data-t="${esc(t)}">${LUPA}${esc(t)}</button>`).join('')}</div>`
      + (vistos.length ? `<p class="w7-so-h">Visto recién</p><div class="w7-so-vistos">${vistos.map((v) => `<a href="${esc(v.url)}"><span class="w7-so-ph"><img alt="" src="${esc(img(v.i, 160))}"></span><span><span class="w7-so-nm">${esc(v.t)}</span>${v.pr ? `<span class="w7-so-pr"><b>${$p(v.pr * 0.75)}</b> transferencia</span>` : ''}</span></a>`).join('')}</div>` : '');
  };

  let ctrl;
  let timer;
  const search = (q) => {
    ctrl?.abort();
    ctrl = new AbortController();
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=hide`;
    fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((j) => {
        const res = j.resources?.results || {};
        const sugs = (res.queries || []).map((x) => x.text).filter((s) => s.toLowerCase() !== q.toLowerCase()).slice(0, 3);
        const prods = res.products || [];
        let html = '';
        if (sugs.length) html += `<p class="w7-so-h">Sugerencias</p><div class="w7-so-sug">${sugs.map((s) => `<button type="button" data-t="${esc(s)}">${LUPA}${esc(s)}</button>`).join('')}</div>`;
        if (prods.length) {
          html += `<p class="w7-so-h">Productos</p><div class="w7-so-res">${prods.slice(0, 6).map((p) => {
            const vimg = plana() && p.variants && p.variants.find((v) => v.featured_image && v.available)?.featured_image?.url;
            const src = vimg || p.featured_image?.url || p.image;
            return `<a href="${esc(p.url)}"><span class="w7-so-ph"><img alt="" loading="lazy" src="${esc(img(src, 300))}"></span><span class="w7-so-nm">${esc(p.title)}</span><span class="w7-so-pr"><b>${$p(Number(p.price) * 0.75)}</b> transferencia</span></a>`;
          }).join('')}</div><a class="w7-so-all" href="/search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last">Ver todos los resultados de «${esc(q)}»</a>`;
        } else {
          html += `<p class="w7-so-vacio">No encontramos «${esc(q)}». Probá con:</p><div class="w7-so-chips">${['jean', 'remera', 'boxy'].map((t) => `<button type="button" data-t="${t}">${t}</button>`).join('')}</div>`;
        }
        if (input.value.trim() === q) body.innerHTML = html;
      })
      .catch(() => {});
  };
  const draw = () => {
    const q = input.value.trim();
    clearTimeout(timer);
    if (!q) { empty(); return; }
    timer = setTimeout(() => search(q), 180);
  };
  input.addEventListener('input', draw);
  body.addEventListener('click', (e) => {
    const b = e.target.closest('[data-t]');
    if (!b) return;
    input.value = b.dataset.t;
    draw();
    input.focus({ preventScroll: true });
  });
  root.addEventListener('w7:open', () => {
    input.value = '';
    empty();
    setTimeout(() => { try { input.focus({ preventScroll: true }); } catch (e) {} }, 60);
  });
})();
